// extracted by mini-css-extract-plugin
module.exports = {"DealEditorBody":"DealEditorBody_DealEditorBody__UIT2E"};